/**
 * Re-export IncrementableInput from a3s-ui as TimeValueControl for backward compat.
 */
export {
  IncrementableInput as TimeValueControl,
  type IncrementableInputProps as TimeValueControlProps,
} from "@visioni/a3s-ui/components";
